const PROCESSING_STATUS = {
  PENDING_GENERATION   : 'pending_generation',
  PENDING_REPROCESSING : 'pending_reprocessing',
  OK                   : 'ok'
};

const RESULT_TYPES = {
  NO_RESULT : 1,
  PARTIAL   : 2,
  FULL      : 3,
  DATE      : 4
};

const getResultTypeId = ({ isReviewSummary = false, showGrade = false, showResultDatetime = null }) => {
  if (!isReviewSummary && !showGrade && !showResultDatetime) {
    return RESULT_TYPES.NO_RESULT;
  }

  if (isReviewSummary && showGrade && !showResultDatetime) {
    return RESULT_TYPES.PARTIAL;
  }

  if (!isReviewSummary && showGrade && !showResultDatetime) {
    return RESULT_TYPES.FULL;
  }

  if (isReviewSummary && showGrade && showResultDatetime) {
    return RESULT_TYPES.FULL;
  }

  if (!isReviewSummary && showGrade && showResultDatetime) {
    return RESULT_TYPES.DATE;
  }
};

module.exports = {
  RESULT_TYPES,
  PROCESSING_STATUS,
  getResultTypeId
};
